import axios from 'axios';

// Get the API base URL 
// This ensures API calls will work in both development and production
const getApiBaseUrl = () => {
  return '/api';
};

// Create a base API instance
const API = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false, // Changed to false for Cloud Run CORS
  timeout: 30000 // Increased timeout for text analysis operations
});

// Export a function to make API calls that handles errors consistently
export const apiCall = async (endpoint, method = 'GET', data = null) => {
  try {
    const fullUrl = `${getApiBaseUrl()}${endpoint}`;
    console.log(`Making API call to: ${fullUrl}`, {
      method,
      data: data ? `${JSON.stringify(data).substring(0, 50)}...` : null,
    });

    const config = {
      method,
      url: endpoint,
    };

    if (data) {
      config.data = data;
    }

    const response = await API(config);
    console.log(`API call to ${endpoint} successful:`, response.status);
    return response.data;
  } catch (error) {
    console.error(`API Error (${endpoint}):`, error);
    console.error('Error details:', {
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
      url: error.config?.url,
      method: error.config?.method,
    });

    // Return a standardized error object
    return {
      error: true,
      message: error.response?.data?.message || 'An unexpected error occurred',
      statusCode: error.response?.status || 500
    };
  }
};

// Export base URL for direct use when needed
export const API_BASE_URL = getApiBaseUrl();

export default API; 